import { useEffect, useState } from "react";
import { outerPages } from "src/config/host";
import { AuthContext } from "src/context/auth";
import Layout from "src/layouts/Layout";
import { setBrowserStyleProperties } from "./helpers/setBrowserStyleProperties";
import { applyCustomFont, applyGlobalHtml } from "./helpers/appHelper";
import { AutoHideScrollbarProvider } from "./context/AutoHideScrollbarContext";
import { SocketProvider } from "./context/SocketContext";
import { SiteSettingsProvider, useSiteSettings } from "./context/SiteSettingsContext";
import useSocketListeners from "./hooks/useSocketListeners";
import { useIframeTrackerLogger } from "./hooks/useIframeTrackerLogger";

const AppContent = () => {
  const [user, setUser] = useState(null);
  const { site, reloadSettings } = useSiteSettings();

  useIframeTrackerLogger(user);

  const allowed_types = ["color_logos", "custom_font", "global_html"];

  useSocketListeners([
    {
      event: "site-settings-updated-response",
      condition: (data) => allowed_types.includes(data?.type),
      handler: reloadSettings,
      title: "Site settings updated",
      message: "Admin has updated site settings. Refreshing changes...",
    },
  ]);

  const isOuterPage = outerPages.includes(window.location.pathname) || window.location.href.includes("/token/") || window.location.href.includes("/forgot-password/") || window.location.href.includes("/storage");

  useEffect(() => {
    if (isOuterPage) {
      setBrowserStyleProperties(document, site);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?._id, isOuterPage]);

  useEffect(() => {
    reloadSettings();
  }, [reloadSettings]);

  useEffect(() => {
    return applyCustomFont(site);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?.custom_font_details, site?.use_custom_font]);

  useEffect(() => {
    if (site?.global_html && user?._id) {
      return applyGlobalHtml(site?.global_html);
    }
  }, [site?.global_html, user?._id]);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <AutoHideScrollbarProvider
        delay={500}
        thickness={6}
        radius={8}
        track="transparent"
        thumbOpacity={0.4}
        mode="global">
        <Layout />
      </AutoHideScrollbarProvider>
    </AuthContext.Provider>
  );
};

function App() {
  return (
    <SocketProvider>
      <SiteSettingsProvider>
        <AppContent />
      </SiteSettingsProvider>
    </SocketProvider>
  );
}

export default App;
